import React, { Component } from 'react'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { Row, Spin, Button } from 'antd'
import { Link } from 'react-router-dom'
import _get from 'lodash/get'
import moment from 'moment'
import { inject, observer } from 'mobx-react'
import EventItem from './EventItem/EventItem'
import FinishedEventItem from './EventItem/FinishedEventItem'
// import EventItemRecent from './EventItem/EventItemRecent'
import withClientId from '~/App/hocs/withClientId'
// import FilterBox from './FilterBox'
import './EventItem/styles.css'

const listEvent = gql`
  query listEvent {
    events {
      _id
      slug
      legacy
      website
      coverUrl
      thumbnailUrl
      hidden
      testMode
      isSoldOut
      isPinned
      name {
        en
        th
        zh
      }
      periods {
        start
        end
        preRegister
        preRegisterStart
        preRegisterEnd
      }
      code
      startDate
      endDate
      hideDate
      location
      published
      whiteLabelUrl
      isRegOpen
      settings {
        _id
        virtualRun {
          _id
          distanceMode
          noEcer
          period {
            start
            end
          }
        }
      }
    }
  }
`
// const clientId = process.env.REACT_APP_CLIENT_ID
@withClientId
@inject('router')
@graphql(listEvent, {
  options: () => ({
    fetchPolicy: 'network-only'
  })
})
@observer
class EventListPage extends Component {
  render () {
    const { clientId } = this.props
    const isRegOpenQuery = _get(this.props, 'router.location.query.isRegOpen', false)
    if (!this.props.data.events) {
      return <div className="modLoadding">
        <Spin tip="Loading..." size="large" />
      </div>
    }
    const currentMoment = moment()
    let events = this.props.data.events.filter(e => !e.hidden || clientId)
    events = isRegOpenQuery ? events.filter(event => event.isRegOpen) : events
    let pinnedEvents = []
    let upcomingEvents = events
      .filter(event => {
        if(event.isPinned) {
          pinnedEvents.push(event)
          return false
        }
        const isBeforeEndPeriods = !!event.periods
          .find(p => currentMoment.isBefore(p.end))
        return event.published && (event.isRegOpen || isBeforeEndPeriods)
      })
      .sort((a, b) => a._id - b._id)
      .sort(e => {
        return (e.periods.find(p => currentMoment.isBefore(p.end)) &&
          !e.isRegOpen) ||
          e.isSoldOut ? 1 : -1
      })
    upcomingEvents = [
      ...pinnedEvents,
      ...upcomingEvents
    ]
    const finishedEvents = events
      .filter(event => {
        if (event.isPinned) return false
        const isBeforeEndPeriods = !!event.periods
          .find(p => currentMoment.isBefore(p.end))
        return !event.isRegOpen && !isBeforeEndPeriods
      })
      .sort((a, b) => moment(b.startDate) - moment(a.startDate))
    return (
      <div>
        <Row>
          {clientId === 'race.thai.run' &&
            <div className="head-topic">
              <div className="head-text-container">
                <div className="introduction">
                  <h1>
                    <div className="text-a">
                      race.thai.run
                    </div>
                    <div className="text-b">
                      <span className="text-b-a">
                        ระบบสมัครงานวิ่งอันดับ 1 ของไทย
                      </span>
                      <span className="text-b-b">
                        สนับสนุนโดย <a href="https://www.trf.or.th/" >สกว. </a>
                      </span>
                    </div>
                    <div className="text-c">
                    สามารถชำระผ่าน <img src='rabbitLinepayLogo.png' alt="rl-logo" /> ได้แล้ว
                    </div>
                  </h1>
                  <div className="divider"></div>
                  <Link to={`/eventForm`} key="eventForm">
                    <Button className="eventFormBtn">
                      สนใจเปิดงานวิ่ง
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          }
          <div className="card-wrapper">
            <div className="card-wrapper-bg">
              {upcomingEvents.length > 0 && <div className="wrap-upcoming">
                <div className="content content-upcoming">
                  <Row>
                    {upcomingEvents.map(event => {
                      const isBeforeEndPeriods = !!event.periods
                        .find(p => currentMoment.isBefore(p.end))
                      return <EventItem {...event}
                        key={event._id} history={this.props.history}
                        isBeforeEndPeriods={isBeforeEndPeriods}/>
                    })}
                  </Row>
                </div>
              </div>}
              {finishedEvents.length > 0 && <div className="wrap-recently">
                <div className="content content-upcoming finishedEvents">
                  <h1> งานวิ่งที่ใช้ระบบรับสมัคร ThaiRun ที่ผ่านมาแล้ว </h1>
                  <Row>
                    {finishedEvents.map(event => (
                      <FinishedEventItem {...event} key={event._id} history={this.props.history}/>
                    ))}
                  </Row>
                </div>
              </div>}
            </div>
          </div>
        </Row>
      </div>
    )
  }
}

export default EventListPage



// WEBPACK FOOTER //
// ./src/App/EventListPage/EventListPage.js